export const isOnlyStateHandleCountries = ['CA', 'GB']

export const countryRule: Record<string, any> = {
    US: {
        zipCode: /^(\d{5})(-\d+)?$/,
    },
    CA: {
        zipCode: /^\w{6}$/,
    }
}